import { useRef, useEffect, useCallback, useState } from 'react';
export function useMouseFocus() {
  const lastInputType = useRef(null);
  const [isMouseFocus, setIsMouseFocus] = useState(false);
  useEffect(() => {
    const handleMouseDown = () => {
      lastInputType.current = 'mouse';
    };
    const handleKeyDown = e => {
      if (e.key === 'Tab' || e.key === 'Enter' || e.key === ' ') {
        lastInputType.current = 'keyboard';
      }
    };
    window.addEventListener('mousedown', handleMouseDown, true);
    window.addEventListener('keydown', handleKeyDown, true);
    return () => {
      window.removeEventListener('mousedown', handleMouseDown, true);
      window.removeEventListener('keydown', handleKeyDown, true);
    };
  }, []);
  const handleMouseFocus = useCallback(() => {
    setIsMouseFocus(lastInputType.current === 'mouse');
  }, []);
  const handleBlur = useCallback(() => {
    setIsMouseFocus(false);
  }, []);
  return {
    isMouseFocus,
    handleMouseFocus,
    handleBlur
  };
}